<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptStops.details.stop_id') }}</label></td>
      <td>{{ details.stop_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptStops.details.name') }}</label></td>
      <td>{{ details.name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptStops.details.zone_id') }}</label></td>
      <td>{{ details.zone_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptStops.details.municipality_id') }}</label></td>
      <td>{{ details.municipality_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('ptStops.details.info') }}</label></td>
      <td><meta-data-details :data="details.info"/></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
  </table>
</template>
<script>
import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

export default {
  name: 'ptScheduleDetails',
  components: {MetaDataDetails},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
